import { render, staticRenderFns } from "./GiftHistoryCard.vue?vue&type=template&id=57920263&scoped=true"
import script from "./GiftHistoryCard.vue?vue&type=script&lang=js"
export * from "./GiftHistoryCard.vue?vue&type=script&lang=js"
import style0 from "./GiftHistoryCard.vue?vue&type=style&index=0&id=57920263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57920263",
  null
  
)

export default component.exports